import { render } from "./permissions-modal.vue?vue&type=template&id=52cddce6&lang=pug"
import script from "./permissions-modal.vue?vue&type=script&lang=js"
export * from "./permissions-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__